var map = {
	"./Basic/SlideShowExtensions": 3576,
	"./Basic/SlideShowExtensions.ts": 3576,
	"./Common/HeaderShipToAddressExtension": 18115,
	"./Common/HeaderShipToAddressExtension.ts": 18115,
	"./Common/HeaderSignInExtension": 65560,
	"./Common/HeaderSignInExtension.ts": 65560,
	"./Header/HeaderLinkListExtension": 43873,
	"./Header/HeaderLinkListExtension.ts": 43873,
	"./ProductDetails/ProductDetailsAttributesExtensions": 2406,
	"./ProductDetails/ProductDetailsAttributesExtensions.ts": 2406,
	"./ProductDetails/ProductDetailsDocumentsExtensions": 36169,
	"./ProductDetails/ProductDetailsDocumentsExtensions.ts": 36169,
	"./ProductDetails/ProductDetailsPriceExtensions": 94358,
	"./ProductDetails/ProductDetailsPriceExtensions.ts": 94358,
	"./ProductList/ProductListActionsExtensions": 38979,
	"./ProductList/ProductListActionsExtensions.ts": 38979,
	"./ProductList/ProductListProductInformationExtensions": 91821,
	"./ProductList/ProductListProductInformationExtensions.ts": 91821,
	"./README.md": 79808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32292;